import { useTranslation } from 'react-i18next'

import { stopPropagation } from '../../../../../../utils/events'
import { EntityArchivedIcon, EntityTag } from '../../../../../Entity'
import { FloatingTooltipContentText } from '../../../../../Floating'
import { ICON_HEIGHT_20 } from '../../../../../Icon'
import { TAG_HEIGHT } from '../../../../../Tag'
import { COPIED_TO_TAG_LIST_FUNCTION_BY_ENTITY } from '../CopiedToTagList.constants'

import { QA_NAME_COPIED_TO_TAG_ITEM } from './CopiedToTagListItem.constants'

function CopiedToTagListItem({
  Icon,
  archived,
  avatarForTag,
  entity,
  height = TAG_HEIGHT.height28,
  id,
  name,
  role,
  onClick,
  onDelete,
  onMouseDown,
}) {
  const { t } = useTranslation()

  function handleClick(event) {
    onClick({ entity, event, id, role })
  }

  function handleMouseDown(event) {
    onMouseDown({ entity, event, id, role })
  }

  function handleDelete(event) {
    stopPropagation(event)

    onDelete?.({
      event,
      getPreparedData: COPIED_TO_TAG_LIST_FUNCTION_BY_ENTITY[entity],
      id,
    })
  }

  return (
    <EntityTag
      Icon={Icon}
      afterContent={
        archived ? (
          <EntityArchivedIcon size={ICON_HEIGHT_20} tooltip={null} />
        ) : null
      }
      avatarProps={avatarForTag}
      height={height}
      name={name}
      qaName={QA_NAME_COPIED_TO_TAG_ITEM}
      removeTooltipKey='Email.RemoveCopyTooltipKey'
      tooltip={
        <FloatingTooltipContentText
          additionalText={t('Copy.ClickToOpenProfileKey')}
          text={name}
        />
      }
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onRemove={handleDelete}
    />
  )
}

export default CopiedToTagListItem
